import React from "react";
import Page from "../Common/Page";
import { http } from "../Common/http";
import { Link } from "react-router-dom";
import { Form, Input, Button, Row, Col, Divider, Alert, Space } from "antd";
import { UserOutlined, LockOutlined, BankOutlined } from "@ant-design/icons";
import { Messages } from "../Common/ValidateMessages";

type FormData = {
  university: string;
  account: string;
  password: string;
};
interface PostSignInData {
  UniversityCode: string;
  UserAccount: string;
  Password: string;
  WindowInnerWidth: number;
  WindowInnerHeight: number;
  ScreenWidth: number;
  ScreenHeight: number;
}
interface SignInDataFromServer {
  userId?: string;
  universityCode?: string;
  mailAddress?: string;
  sei?: string;
  mei?: string;
  accessToken?: string;
  errorType?: number;
  loginTryCount?: number;
}

export default class SignInPage extends React.Component {
  state = {
    loginError: "none",
    loginErrorMsg: "",
  };
  private _page: React.RefObject<Page>;
  constructor(props) {
    super(props);
    this._page = React.createRef<Page>();
  }
  submitForm = async (data: FormData) => {
    try {
      this.setState({ loginError: "none" });
      this.setState({ loginErrorMsg: "" });
      this._page.current?.setState({ isPageLoading: true });
      const signinData: PostSignInData = {
        UniversityCode: data.university,
        UserAccount: data.account,
        Password: data.password,
        WindowInnerWidth: window.innerWidth,
        WindowInnerHeight: window.innerHeight,
        ScreenWidth: window.screen.availWidth,
        ScreenHeight: window.screen.availHeight,
      };
      const result = await http<SignInDataFromServer, PostSignInData>({
        path: "/Login",
        method: "post",
        body: signinData,
      });
      if (result.ok && result.body) {
        sessionStorage.setItem("auth", result.body.accessToken!);
        this._page.current?.setState({ isPageLoading: false });
        window.location.replace(window.location.origin);
      } else {
        sessionStorage.removeItem("auth");
        this.setState({ loginError: "" });
        if (result.body?.errorType === 1) {
          this.setState({ loginErrorMsg: Messages["ERR-001"] });
        } else if (result.body?.errorType === 2) {
          this.setState({ loginErrorMsg: Messages["ERR-001"] });
        } else if (result.body?.errorType === 3) {
          this.setState({ loginErrorMsg: Messages["ERR-001"] });
        } else {
          this.setState({ loginErrorMsg: Messages["ERR-001"] });
        }
        this._page.current?.setState({ isPageLoading: false });
      }
    } catch (error) {
      sessionStorage.removeItem("auth");
      this.setState({ loginError: "" });
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  onFormValueChange = () => {
    this.setState({ loginError: "none" });
  };

  render() {
    return (
      <Page ref={this._page} noCheckAuthority={true}>
        <Row justify="center">
          <Col span={6}>
            <h1 className="iiscore-title">iiscore-U</h1>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={6}>
            <Divider orientation="left">ログイン</Divider>
          </Col>
        </Row>
        <Row justify="center" style={{ display: this.state.loginError }}>
          <Col span={6}>
            <Alert
              type="error"
              description={this.state.loginErrorMsg}
              message="エラー"
            />
          </Col>
        </Row>

        <Row justify="center">
          <Col span={6}>
            <Form
              name="login"
              layout="vertical"
              onFinish={this.submitForm}
              onValuesChange={this.onFormValueChange}
              autoComplete="off"
              className="login-form"
            >
              <Form.Item
                name="university"
                label="大学コード"
                rules={[
                  {
                    required: true,
                    whitespace: true,
                  },
                ]}
              >
                <Input
                  prefix={<BankOutlined className="site-form-item-icon" />}
                  size="middle"
                  placeholder="大学コード"
                  maxLength={7}
                />
              </Form.Item>
              <Form.Item
                name="account"
                label="ユーザアカウント"
                rules={[
                  {
                    required: true,
                    whitespace: true,
                  },
                ]}
              >
                <Input
                  prefix={<UserOutlined className="site-form-item-icon" />}
                  size="middle"
                  placeholder="ユーザアカウント"
                  maxLength={30}
                />
              </Form.Item>
              <Form.Item
                name="password"
                label="パスワード"
                rules={[
                  {
                    required: true,
                    whitespace: true,
                  },
                ]}
              >
                <Input.Password
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  placeholder="パスワード"
                  size="middle"
                  maxLength={30}
                />
              </Form.Item>
              <br />
              <Form.Item>
                <Space split={<Divider type="vertical" />} size={"large"}>
                  <Button
                    size="middle"
                    type="primary"
                    htmlType="submit"
                    className="login-form-button"
                  >
                    ログイン
                  </Button>
                  <Link to={"/Reminder"}>パスワードを忘れた方はこちら</Link>
                </Space>
              </Form.Item>
            </Form>
          </Col>
        </Row>
        {/* </Spin> */}
      </Page>
    );
  }
}
